import { JournalContainerModel } from './../../../../../../models/aggregates/erp/journal/journal-container.model';
import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import { Observable } from 'rxjs';
import { ApiVisa, BasicApiResponseModel } from '../../shared';




@Injectable({
  providedIn: 'root'
})
export class JournalService extends BaseApiTemplateService<JournalContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'journals';

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'journals';
    this.httpClient = http;
  }


  public printJournal(formatGuid: string, body: any, apiVisa: ApiVisa) {
    let url = apiVisa.api_domain_url + this.endpoint_path + '/voucher/batch-print-jasper-pdf/backoffice-ep?printableFormatHdrGuid=' + formatGuid;
    return this.httpClient.post(url, body, this.getHttpHeaderBlob(apiVisa))
  }

  public cloneDocument(guid: string, apiVisa: ApiVisa) {
    let url;
    if (this.endpoint_path && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + this.endpoint_path + "/clone/backoffice-ep/" + guid;
    }  
    return this.httpClient.post<BasicApiResponseModel<JournalContainerModel>>(
      url, null, this.getHttpHeader(apiVisa)
    );
  }
}
